import ko from 'knockout';

export class MissingCompetentionModel {
    id: KnockoutObservable<string>;
    name: KnockoutObservable<string>;
    
    constructor(model: any = {}) {
        this.id = ko.observable<string>(model.id);
        this.name = ko.observable<string>(model.name);
    }
}